module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074bd_banner_800x600.ab56fb1f.png";